import React, { lazy } from 'react';
import { Section } from './Shared';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function Problem() {
  const comparisons = [{
    bad: 'Cuánto recibirán exactamente en pesos',
    good: 'Tu proyección exacta de mesada mensual'
  }, {
    bad: 'Si les faltan semanas en su historial',
    good: 'Auditoría forense semana por semana'
  }, {
    bad: 'En qué régimen les conviene estar',
    good: 'Comparativa actuarial de ambos regímenes'
  }, {
    bad: 'Si su pensión cubrirá su estilo de vida',
    good: 'Cálculo real de tu brecha pensional'
  }, {
    bad: 'Cómo reclamar semanas no reportadas',
    good: 'Derecho de petición listo para radicar'
  }];
  return <Section bg="slate" data-id="element-121">
      <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center mb-12 max-w-5xl mx-auto" data-id="element-122">
        <div className="relative order-2 lg:order-1" data-id="element-123">
          <img src="https://cdn.magicpatterns.com/uploads/5yunEdieSR3rfzF5vSL1Pi/Imagen_1_pagina_Solucion_a_Pension.png" alt="Hombre preocupado revisando facturas y documentos sobre su mesa por la noche" className="w-full rounded-2xl shadow-lg object-cover" loading="lazy" data-id="element-124" />
        </div>
        <div className="text-center lg:text-left order-1 lg:order-2" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900" data-id="element-126">
            La mayoría de colombianos llegan a los 55 años sin saber tres datos
            fundamentales sobre su pensión.
          </h2>
        </div>
      </div>

      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden mb-12" data-id="element-127">
        <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-128">
          {/* Bad Column */}
          <div className="bg-slate-50 p-6 md:p-8 border-b md:border-b-0 md:border-r border-slate-200" data-id="element-129">
            <h3 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-130">
              <XCircle className="w-6 h-6 text-red-500" data-id="element-131" />
              Lo que NO saben
            </h3>
            <ul className="space-y-5" data-id="element-132">
              {comparisons.map((item, i) => <li key={i} className="text-slate-600 flex items-start gap-3" data-id="element-133">
                  <span className="w-1.5 h-1.5 rounded-full bg-red-400 mt-2 flex-shrink-0" data-id="element-134"></span>
                  <span data-id="element-135">{item.bad}</span>
                </li>)}
            </ul>
          </div>

          {/* Good Column */}
          <div className="p-6 md:p-8" data-id="element-136">
            <h3 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-137">
              <CheckCircle2 className="w-6 h-6 text-[#25D366]" data-id="element-138" />
              Lo que nosotros te decimos
            </h3>
            <ul className="space-y-5" data-id="element-139">
              {comparisons.map((item, i) => <li key={i} className="text-slate-800 font-medium flex items-start gap-3" data-id="element-140">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#25D366] mt-2 flex-shrink-0" data-id="element-141"></span>
                  <span data-id="element-142">{item.good}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto space-y-4 text-lg text-slate-700" data-id="element-143">
        <p data-id="element-144">Eso no es descuido tuyo.</p>
        <p data-id="element-145">
          Es que ni los fondos privados ni Colpensiones tienen incentivo para
          explicártelo.
        </p>
        <p data-id="element-146">
          A ellos les conviene que te quedes donde estás, confundido y sin
          comparar.
        </p>
        <p className="font-semibold text-slate-900 text-xl pt-2" data-id="element-147">
          A nosotros nos conviene una sola cosa: que tomes la decisión correcta
          para tu perfil específico.
        </p>
      </div>
    </Section>;
}